import {
  Box,
  Button,
  Grid,
  Typography,
  Link,
  AppBar,
  Toolbar,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../../Components/CustomInput";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import DataService from "../../../../../Service";
import { useHistory } from "react-router";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  overviewContainer: {
    position: "sticky",
    top: 64,
    paddingTop: 40,
    background: "#fff",
    zIndex: 1,
  },
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
    marginBottom: "2rem",
  },
}));

function Extension(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const globaluserData = useSelector((state) => state.commonReducer);
  const themeColor = globaluserData?.role === "admin" ? "#3B86FF" : "#981B1E";
    // sessionStorage.getItem("role") == "admin" ? "#3B86FF" : "#981B1E";
  const [userData, setUserData] = useState({});
  const [extensionStatus, setExtensionStatus] = useState("");

  const history = useHistory();
  const setInputState = (inputStateValue, inputId) => {
    setUserData((oldValue) => ({ ...oldValue, [inputId]: inputStateValue }));
  };

  useEffect(() => {
    if (props?.fetchData) {
      setUserData({
        response_from_coach: props?.fetchData?.data?.response_from_coach || "",
        response_from_coachee:
          props?.fetchData?.data?.response_from_coachee || "",
        response_from_line_manager:
          props?.fetchData?.data?.response_from_line_manager || "",
        other_notes: props?.fetchData?.data?.other_notes || "",
        extensionName: props?.fetchData?.data?.extension_name || "",
      });
      setExtensionStatus(props?.fetchData?.flag);
    }
  }, [props?.fetchData]);

  const handleCreateAssignment = () => {
    if (props?.fetchData?.flag.includes("View")) {
      history.push({
        pathname: "assignmentoverview",
        state: {
          currentAssignment: {
            id: props?.fetchData?.data?.child_assignment_id,
          },
        },
      });
    } else {
      const param = {
        assignment_id: props?.assignmentId,
        extension_id: props?.fetchData?.data?.id,
      };

      DataService.createData(param, "create_assignment_from_extension")
        .then((res) => {
          if (res?.success) {
            props?.setNewAssignmentData({ ...res, extension: true });
            props?.setAssignmentDrawer("edit");
            props?.setRefresh(false);
          }
        })
        .catch((error) => {});
    }
  };

  const saveExtention = (e) => {
    if (props?.fetchData?.data) {
      const pdata = {
        assignment_id: props.assignmentId,
        extension_id: props?.fetchData?.data?.id,
        ...userData,
      };
      DataService.updateData(pdata, "", "update_extension").then((response) => {
        if (response?.success) {
          dispatch(showSnackbar("Success", ["Extension Updated Successfully"]));
        }
      });
    } else {
      const pdata = {
        assignment_id: props.assignmentId,
        ...userData,
      };
      DataService.createData(pdata, "create_extension").then((response) => {
        if (response?.success) {
          dispatch(showSnackbar("Success", [response.message]));
          props?.setRefresh((oldValue) => !oldValue);
        }
      });
    }
  };

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid
          item
          xs={11}
          style={{ textAlign: "center" }}
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.overviewContainer}
        >
          <AppBar position="static" className={classes.appBar} elevation={0}>
            <Toolbar>
              <Grid
                container
                direction="row"
                justify="left"
                alignItems="left"
                xs={12}
              >
                <Grid item xs={6}>
                  <Typography variant="h1" style={{ color: "#232323" }}>
                    <Box textAlign="left" fontWeight="fontWeightBold">
                      Coaching request form
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              {userData?.extensionName || "Extension"}
            </Typography>
            {extensionStatus?.includes("Create") ? (
              <Button
                disableElevation
                variant="contained"
                style={{
                  textTransform: "none",
                  backgroundColor: "#38B122",
                  color: "#fff",
                }}
                onClick={handleCreateAssignment}
              >
                {extensionStatus}
              </Button>
            ) : (
              <Link
                href="javascript:void(0)"
                onClick={handleCreateAssignment}
                color="inherit"
                style={{ color: themeColor }}
              >
                {extensionStatus}
              </Link>
            )}
          </Box>
        </Grid>
        <Grid item xs={11}>
          <Grid item xs={10}>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 20 }}
            >
              <Grid item xs={3}>
                <Typography variant="h2">Response from coach</Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomInput
                autoFocus={true}
                  id="response_from_coach"
                  multiline={true}
                  rows={4}
                  variant="outlined"
                  placeholder="Response from coach"
                  parentcall={setInputState}
                  value={userData?.response_from_coach}
                  required
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 10 }}
            >
              <Grid item xs={3}>
                <Typography variant="h2">Response from coachee</Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomInput
                  id="response_from_coachee"
                  multiline={true}
                  rows={4}
                  variant="outlined"
                  placeholder="Response from coachee"
                  parentcall={setInputState}
                  value={userData?.response_from_coachee}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 10 }}
            >
              <Grid item xs={3}>
                <Typography variant="h2">
                  Response from HRBP/ Line Manager
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomInput
                  id="response_from_line_manager"
                  multiline={true}
                  rows={4}
                  variant="outlined"
                  placeholder="Response from HRBP/ Line Manager"
                  parentcall={setInputState}
                  value={userData?.response_from_line_manager}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 10 }}
            >
              <Grid item xs={3}>
                <Typography variant="h2">
                  Other notes (Costs and other details)
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomInput
                  id="other_notes"
                  multiline={true}
                  autoFocus
                  rows={4}
                  variant="outlined"
                  placeholder="Other notes (Costs and other details)"
                  parentcall={setInputState}
                  value={userData?.other_notes}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 10 }}
            >
              <Grid item xs={12}>
                <Box textAlign="right">
                  <Button
                    disableElevation
                    variant="contained"
                    style={{ textTransform: "none", marginRight: 10 }}
                  >
                    Cancel
                  </Button>
                  <Button
                    disableElevation
                    variant="contained"
                    onClick={saveExtention}
                    color="primary"
                    style={{ textTransform: "none" }}
                  >
                    {props?.fetchData?.data ? "Update changes" : "Save changes"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Extension;
